import * as React from "react"
const IconDot = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props?.width ?? 8}
        height={props?.height ?? 8}
        fill="none"
        viewBox="0 0 8 8"
        {...props}
    >
        <circle cx={4} cy={4} r={4} fill={props?.fill ?? "#D5D7DA"} />
    </svg>
)
export default IconDot
